export { VoiceSupportCard } from './voice-support-card.component';
